import { computed } from '@ember/object';
import Component from '@glimmer/component';
import EnvironmentModel from 'cio/models/environment';
import { EditableEnvironment } from 'cio/utils/environment/editable';
import { IdentifierKey, IdentifierState } from 'cio/utils/identifiers';
import { IdentifierType } from 'cio/utils/identifiers';

interface SettingsWorkspaceIdentifiersBaseArgs {
  environment: EnvironmentModel;
  editableEnvironment: EditableEnvironment;
  readOnly: boolean;
  isMigrating: boolean;
  identifier: IdentifierKey;
  onToggleChangeIdentifiersById: () => unknown;
  onChangeIdMutability: () => unknown;
  onChooseMigrate: () => unknown;
}

export default class SettingsWorkspaceIdentifiersBase extends Component<SettingsWorkspaceIdentifiersBaseArgs> {
  readonly identifierKey = IdentifierKey;
  readonly identifierState = IdentifierState;
  readonly identifierType = IdentifierType;

  @computed('args.environment.identifiers.[]')
  get canIdentifyByEmailInMultiId() {
    return this.args.environment.isMultiIdentifier && this.args.environment.canIdentifyByEmail;
  }
}
